import React, { lazy } from "react";
import AuthRoute from "../../components/auth/AuthRoute";
import BrouchureLinks from "../../components/layout/BrouchureLinks";
import RoleRoutes from "../RoleRoutes";

export const pathName = "/sales-coordinator";

/* -----------------------------------
 PATH SEGMENTS
------------------------------------ */
export const paths = {
    cab: "/cab-details",
    conversion: "/booking-conversion",
    avail: "/availability-and-cost-sheet",
    reports: "/reports",
    blocking: "/blocking",
    search: "/search",
    bookingForm: "/booking_form",
    sales: "/sales-coordinator",
};

/* -----------------------------------
 LANDING PAGE
------------------------------------ */
export const landing = `${pathName}${paths.bookingForm}`;

/* -----------------------------------
 FULL PAGE URLS
------------------------------------ */
export const pages = {
    landing,
    cab: `${pathName}${paths.cab}`,
    conversion: `${pathName}${paths.conversion}`,
    avail: `${pathName}${paths.avail}`,
    reports: `${pathName}${paths.reports}`,
    blocking: `${pathName}${paths.blocking}`,
    bookingForm: `${pathName}${paths.bookingForm}`,

    // ✅ DETAIL PAGE HELPER — USE THIS EVERYWHERE
    bookingFormDetail: (bookingId) =>
        `${pathName}${paths.bookingForm}/${bookingId}`,
};

/* -----------------------------------
 SIDE MENU
------------------------------------ */
export const menu = [
    {
        title: "Booking Form",
        to: pages.bookingForm,
    },
    {
        title: "Cab Details",
        to: pages.cab,
    },
    {
        title: "Booking Conversion",
        to: pages.conversion,
    },
    {
        title: "Availability and Cost Sheet",
        to: pages.avail,
    },
    {
        title: "Blocking",
        to: pages.blocking,
    },
    {
        title: "Reports",
        to: pages.reports,
    },
];

/* -----------------------------------
 ROUTES
------------------------------------ */
export const routes = [
    {
        path: paths.bookingForm,
        component: lazy(() => import("./BookingForm")),
        exact: true,
    },
    {
        path: paths.cab,
        component: lazy(() => import("./CabDetails")),
        exact: true,
    },
    {
        path: paths.conversion,
        component: lazy(() => import("./Conversion")),
        exact: true,
    },
    {
        path: paths.blocking,
        component: lazy(() => import("./Blocking")),
        exact: true,
    },
    {
        path: paths.reports,
        component: lazy(() => import("./Reports")),
        exact: true,
    },
    {
        path: paths.avail,
        component: lazy(() => import("../sales-manager/Availability")),
        exact: true,
    },
    {
        path: paths.search,
        component: lazy(() => import("../OverallSearchResult")),
        exact: true,
    },

    /* -------- Availability sub routes ---------- */
    {
        path: `${paths.avail}/tower-wise-availability`,
        component: lazy(() => import("../sales-manager/TowerAvailability")),
    },
    {
        path: `${paths.avail}/project-cost-sheet`,
        component: lazy(() => import("../sales-manager/ProjectCostSheet")),
    },
    {
        path: `${paths.avail}/tower-reports`,
        component: lazy(() => import("../sales-manager/TowerReport")),
    },
    {
        path: `${paths.avail}/apartment/:apartmentId`,
        component: lazy(() => import("../sales-manager/Apartment")),
    },

    /* -------- Blocking sub routes ---------- */
    {
        path: `${paths.blocking}/tower-wise-availability`,
        component: lazy(() => import("../sales-manager/TowerAvailability")),
    },
    {
        path: `${paths.blocking}/project-cost-sheet`,
        component: lazy(() => import("../sales-manager/ProjectCostSheet")),
    },
    {
        path: `${paths.blocking}/tower-reports`,
        component: lazy(() => import("../sales-manager/TowerReport")),
    },
    {
        path: `${paths.blocking}/apartment/:apartmentId`,
        component: lazy(() => import("../sales-manager/Apartment")),
    },

    /* -------- Conversion ---------- */
    {
        path: `${paths.conversion}/convert/:leadId`,
        component: lazy(() => import("../sales-manager/Convert")),
    },

    /* -------- Booking Form Detail ---------- */
    {
        path: `${paths.bookingForm}/booking_form/:bookingId`,
        component: lazy(() =>
            import("../crm-executives/Sales/BookingForm/BookingForm")
        ),
    },

    /* -------- Lead Views ---------- */
    {
        path: `${paths.cab}/view/:leadId`,
        component: lazy(() => import("../tele-caller/LeadDetails")),
    },
    {
        path: `${paths.conversion}/view/:leadId`,
        component: lazy(() => import("../tele-caller/LeadDetails")),
    },
    {
        path: `${paths.search}/view/:leadId`,
        component: lazy(() => import("../tele-caller/LeadDetails")),
    },
];

export const allowRoles = [8];

/* -----------------------------------
 EXPORT WRAPPER
------------------------------------ */
export default (
    <AuthRoute path={pathName}>
        <RoleRoutes
            title="Sales Co-ordinator"
            routes={routes}
            allowRoles={allowRoles}
            menu={menu}
            landing={landing}
            headerRight={<BrouchureLinks />}
        />
    </AuthRoute>
);
